import AppHttpClient from '../api-manager/api/http-client';
import HttpPathsEnum from '../api-manager/api/http-paths.enum';
import { BookLounge } from '../../store/lounges/loungesManagementTypes';
import { HttpRequest, RequestType } from '../api-manager/api/http-request';
import { ResourceResponseDto } from './dto/response/get-resources-response.dto';
import { GetResourceByIdResponseDto } from './dto/response/get-resource-by-id-response.dto';
import { CreateResourceAllocResponseDto } from '../room/dto/response/create-alloc-response.dto';

const RESOURCE_PATH = HttpPathsEnum.RESOURCE;

class LoungeManagementApi {
  public async getLounges() {
    const request: HttpRequest = {
      url: `${RESOURCE_PATH}/resource/get-all-lounges`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, ResourceResponseDto[]>(
      request,
      ResourceResponseDto
    );
  }

  public async getLoungeById(id: number) {
    const request: HttpRequest = {
      url: `${RESOURCE_PATH}/resource/${id}`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetResourceByIdResponseDto>(
      request,
      GetResourceByIdResponseDto
    );
  }

  public async bookLoungeAllocation(
    createResourceAllocDto: BookLounge,
    creditBalanceDto: any
  ) {
    const request: HttpRequest = {
      url: `${RESOURCE_PATH}/resource-alloc`,
      method: RequestType.POST,
      data: {
        createResourceAllocDto,
        creditBalanceDto,
      },
    };

    return await AppHttpClient.exec<any, BookLounge>(
      request,
      CreateResourceAllocResponseDto
    );
  }

  public async getMyLoungeByLocationId(id: number) {
    const request: HttpRequest = {
      url: `${RESOURCE_PATH}/resource/lounge-by-location-id/${id}`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, ResourceResponseDto>(
      request,
      ResourceResponseDto
    );
  }

  public async getValidLoungeById(id: number) {
    const request: HttpRequest = {
      url: `${RESOURCE_PATH}/resource/find-valid-resource-by-id/${id}`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetResourceByIdResponseDto>(
      request,
      GetResourceByIdResponseDto
    );
  }
}

export default new LoungeManagementApi();
